// import { gsap } from 'gsap';

export default class Animation {

    constructor() {
        this.init();
    }

    init() {
        // ローディング画面を非表示
        this.hideLoading();

        // イントロを非表示
        this.hideIntro();
    }

    hideLoading() {
        const $intro = document.getElementById('js-intro');

        window.addEventListener('load', () => {
            $intro.classList.remove('-loading');
            $intro.classList.add('-animation');
        });

    }

    hideIntro() {
        const $intro = document.getElementById('js-intro');
        const $start = document.getElementById('js-start');

        $start.addEventListener('click', () => {
            $intro.classList.add('-start');
            setTimeout(() =>{
                $intro.style.display = 'none';
            }, 2000)
        });
    }
}
